export const SPY_USER_EMAIL = 'spy@nemuru.com';
